import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import styles from './ProductSheet.module.scss';
import Select from '../../widget/inputs/Select';
import WidgetFrame from '../../widget/navigation/WidgetFrame';
import Window from '../../widget/windows/window';
import { Product } from '../../../dataTypes/productManagment/types';

// import   ProductSheet_ForPhysicalProduct    from './ProductSheet_ForPhysicalProduct';
// import   ProductSheet_ForSubscription       from './ProductSheet_ForSubscription';
// import   ProductSheet_ForPaidVideo          from './ProductSheet_ForPaidVideo';
// import   ProductSheet_ForPaidChannel        from './ProductSheet_ForPaidChannel';

import   ProductSheetDetails    from './ProductSheetDetails';

export interface ProductSheetProps {
  product?: Product;
  onCreate?: (id: number) => void;
  onEdit?: (id: number) => void;
  productKind?: string;
}

export const ProductSheet = ({
  product,
  onCreate,
  onEdit,
  productKind = '',
}: ProductSheetProps) => {
  const isEditMode = product !== undefined;
  const productKindMapping: { [key: string]: string } = {
    'Physical Item': 'Produit physique',
    Subscription: 'Abonnement',
    PayVideo: 'Vidéo payante',
    PayChannel: 'Chaîne payante',
    CreatorCapacity: 'Quota créateur',
  };
  const productToCreateTypeNames = [
    'Produit physique',
    'Abonnement',
    'Vidéo payante',
    'Chaîne payante',
    'Quota créateur',
  ];

  const [selectedProductToCreateType, setSelectedProductToCreateType] = useState(
    isEditMode
      ? productKindMapping[product?.kind ?? 'default']
      : productKind
      ? productKindMapping[productKind ?? 'default']
      : ''
  );
  const [informationMessage, setInformationMessage] = useState(<></>);
  const [showInformationWindow, setShowInformationWindow] = useState(false);
  const [id, setId] = useState(0);

  const creationWindowRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (creationWindowRef.current) {
      creationWindowRef.current.scrollTop = 0;
    }
  }, [selectedProductToCreateType]);

  useEffect(() => {
    console.log('productSheet', product, productKind);
  }, []);

  const handleProductToCreateTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedProductToCreateType(e.target.value);
  };


  const handleProductSheetForPhysicalProductCreation = (id: number) => {
    if (id !== 0) {
      setInformationMessage(<>Le produit physique n°{id} a été créée</>);
      setShowInformationWindow(true);
      setId(id);
    } else {
      if (isEditMode) {
        if (onEdit) {
          onEdit(id);
        }
      } else {
        if (onCreate) {
          onCreate(id);
        }
      }
    }
  };

  const handleProductSheetForPhysicalProductEdition = (id: number) => {
    if (id !== 0) {
      setInformationMessage(<>La produit physique n°{id} a été modifiée</>);
      setShowInformationWindow(true);
      setId(id);
    } else {
      if (isEditMode) {
        if (onEdit) {
          onEdit(id);
        }
      } else {
        if (onCreate) {
          onCreate(id);
        }
      }
    }
  };

  const handleProductSheetForSubscriptionCreation = (id: number) => {
    if (id !== 0) {
      setInformationMessage(<>L'abonnement n°{id} a été créé</>);
      setShowInformationWindow(true);
      setId(id);
    } else {
      if (isEditMode) {
        if (onEdit) {
          onEdit(id);
        }
      } else {
        if (onCreate) {
          onCreate(id);
        }
      }
    }
  };

  const handleProductSheetForSubscriptionEdition = (id: number) => {
    if (id !== 0) {
      setInformationMessage(<>L'abonnement n°{id} a été modifié</>);
      setShowInformationWindow(true);
      setId(id);
    } else {
      if (isEditMode) {
        if (onEdit) {
          onEdit(id);
        }
      } else {
        if (onCreate) {
          onCreate(id);
        }
      }
    }
  };

  const handleProductSheetForPaidVideoCreation = (id: number) => {
    if (id !== 0) {
      setInformationMessage(<>La vidéo payante n°{id} a été créé</>);
      setShowInformationWindow(true);
      setId(id);
    } else {
      if (isEditMode) {
        if (onEdit) {
          onEdit(id);
        }
      } else {
        if (onCreate) {
          onCreate(id);
        }
      }
    }
  };

  const handleProductSheetForPaidVideoEdition = (id: number) => {
    if (id !== 0) {
      setInformationMessage(<>Le vidéo payante n°{id} a été modifié</>);
      setShowInformationWindow(true);
      setId(id);
    } else {
      if (isEditMode) {
        if (onEdit) {
          onEdit(id);
        }
      } else {
        if (onCreate) {
          onCreate(id);
        }
      }
    }
  };

  const handleProductSheetForPaidChannelCreation = (id: number) => {
    if (id !== 0) {
      setInformationMessage(<>La chaîne payante n°{id} a été créée</>);
      setShowInformationWindow(true);
      setId(id);
    } else {
      if (isEditMode) {
        if (onEdit) {
          onEdit(id);
        }
      } else {
        if (onCreate) {
          onCreate(id);
        }
      }
    }
  };

  const handleProductSheetForPaidChannelEdition = (id: number) => {
    if (id !== 0) {
      setInformationMessage(<>La chaîne payante n°{id} a été modifiée</>);
      setShowInformationWindow(true);
      setId(id);
    } else {
      if (isEditMode) {
        if (onEdit) {
          onEdit(id);
        }
      } else {
        if (onCreate) {
          onCreate(id);
        }
      }
    }
  };

  const handleProductSheetForCreatorCapacityCreation = (id: number) => {
    if (id !== 0) {
      setInformationMessage(<>Le quota créateur n°{id} a été créé</>);
      setShowInformationWindow(true);
      setId(id);
    } else {
      if (isEditMode) {
        if (onEdit) {
          onEdit(id);
        }
      } else {
        if (onCreate) {
          onCreate(id);
        }
      }
    }
  };

  const handleProductSheetForCreatorCapacityEdition = (id: number) => {
    if (id !== 0) {
      setInformationMessage(<>Le quota créateur n°{id} a été modifié</>);
      setShowInformationWindow(true);
      setId(id);
    } else {
      if (isEditMode) {
        if (onEdit) {
          onEdit(id);
        }
      } else {
        if (onCreate) {
          onCreate(id);
        }
      }
    }
  };

  const handleInformationWindowClosure = () => {
    setShowInformationWindow(false);
    if (isEditMode) {
      if (onEdit) {
        onEdit(id);
      }
    } else {
      if (onCreate) {
        onCreate(id);
      }
    }
  };

  return (
    <div className={classNames(styles.root)}>
      {showInformationWindow && (
        <Window
          message={informationMessage}
          onClickOnValidateButton={handleInformationWindowClosure}
        />
      )}
      <div className={classNames(styles.creation_window_scrollable)} ref={creationWindowRef}>
        <div className={classNames(styles.creation_window_content)}>
          {!isEditMode && !productKind && (
            <div className={classNames(styles.creation_window_productKindChoice)}>
              <WidgetFrame
                name="Type de produit :"
                error=""
                labelTextPosition="right"
                labelBlockPosition="left"
                classNameGrid={classNames(styles.grid_frame)}
              >
                <Select
                  choices={productToCreateTypeNames}
                  value={selectedProductToCreateType}
                  onChange={handleProductToCreateTypeChange}
                  placeholder="Choisissez un type de produit"
                  showPlaceholder={true}
                  placeholderValue=""
                />
              </WidgetFrame>
            </div>
          )}
          {
           selectedProductToCreateType === productToCreateTypeNames[0] && 
           !isEditMode && 
           (
            <ProductSheetDetails productType = "Physical Item"
                                 product     = {product}
                                 onCreate    = {handleProductSheetForPhysicalProductCreation} />
           )
          }
          {
           selectedProductToCreateType === productToCreateTypeNames[1] && 
           !isEditMode && 
           (
            <ProductSheetDetails productType = "Subscription"
                                 product     = {product}
                                 onCreate    = {handleProductSheetForSubscriptionCreation} />
           )
          }
          {
           selectedProductToCreateType === productToCreateTypeNames[2] && 
           !isEditMode && 
           (
            <ProductSheetDetails productType = "PayVideo"
                                 product     = {product}
                                 onCreate    = {handleProductSheetForPaidVideoCreation} />
           )
          }
          {
           selectedProductToCreateType === productToCreateTypeNames[3] &&
           !isEditMode &&
           (
            <ProductSheetDetails productType = "PayChannel"
                                 product     = {product}
                                 onCreate    = {handleProductSheetForPaidChannelCreation} />
           )
          }
          {
           selectedProductToCreateType === productToCreateTypeNames[4] &&
           !isEditMode &&
           (
            <ProductSheetDetails productType = "CreatorCapacity"
                                 product     = {product}
                                 onCreate    = {handleProductSheetForCreatorCapacityCreation} />
           )
          }
          {
           selectedProductToCreateType === productToCreateTypeNames[0] &&
           isEditMode &&
           (
            <ProductSheetDetails productType = "Physical Item"
                                 product     = {product}
                                 onEdit      = {handleProductSheetForPhysicalProductEdition} />
           )
          }
          {
           selectedProductToCreateType === productToCreateTypeNames[1] && 
           isEditMode && 
           (
            <ProductSheetDetails productType = "Subscription"
                                 product     = {product}
                                 onEdit      = {handleProductSheetForSubscriptionEdition} />
           )
          }
          {
           selectedProductToCreateType === productToCreateTypeNames[2] && 
           isEditMode && 
           (
            <ProductSheetDetails productType = "PayVideo"
                                 product     = {product}
                                 onEdit      = {handleProductSheetForPaidVideoEdition} />
           )
          }
          {
           selectedProductToCreateType === productToCreateTypeNames[3] &&
           isEditMode &&
           (
            <ProductSheetDetails productType = "PayChannel"
                                 product     = {product}
                                 onEdit      = {handleProductSheetForPaidChannelEdition} />
           )
          }
          {
           selectedProductToCreateType === productToCreateTypeNames[4] &&
           isEditMode &&
           (
            <ProductSheetDetails productType = "CreatorCapacity"
                                 product     = {product}
                                 onEdit      = {handleProductSheetForCreatorCapacityEdition} />
           )
          }
        </div>
      </div>
    </div>
  );
};

export default ProductSheet;